export const userRoles = {
  ADMIN: {
    canAccess: [
      "/",
      "/onboard/config",
      "/pam/endpointsUsers",
      "/pam/endpointuserDetails",
      "/pam/endpointGroups",
      "/pam/endpointGroups/endpointGroupDetails",
      "/pam/endpoint",
      "/pam/endpoint/endpointDetails",
      "/pam/endpoint/addEndpoint/windows",
      "/pam/endpoint/addEndpoint/linux",
      "/pam/endpoint/passwordPolicies",
      "/pam/endpoint/agentLogs",
      "/pam/jumpServer",
      "/pam/jumpServer-sessionRecordings",
      "/pam/credentialRotation",
      "/pam/credentialRotation/addPassword",
      "/pam/credentialRotation/addSshKeys",
      "/pam/policy-request",
      "/pam/policy",
      "/pam/policy-logs",
      "/pam/auth-logs",
      "/pam/policy/createEndpointAccessPolicy",
      "/pam/secrets",
      "/pam/databases",
      "/pam/databases/dashboard",
      "/pam/databases/agents",
      "/pam/databases/connections",
      "/pam/databases/users",
      "/pam/databases/userPrivileges",
      "/pam/databases/add/windows",
      "/pam/databases/add/linux",
      "/pam/secrets/add",
      "/workloadIdentity",
      "/workloadIdentity/addWorkloadIdentity",
      "/serviceCredentials",
      "/serviceAccount/addServiceAccount",
      "/serviceAccount",

      "/directory/users",
      "/directory/groups",
      "/directory/device",
      "/directory/activeDirectory",
      "/directory/platform-users",

      "/windows/endpoints",
      "/windows/endpointPolicies",
      "/windows/createWindowPolicy",
      "/windows/requestLogs",
      "/windows/auditLogs",
      "/windows/applicationRequest",

      "/onboard",
      "/onboard/module",
      "/onboard/setup/serviceAccount",
      "/onboard/setup/mfa",
      "/onboard/setup/localAccount",
      "/onboard/setup/tenantConfig",
      "/splunk",
      "/tenantConfig",
      "/dit/endpointRules",
      "/dit/createPolicy",

      // UI Prototype
      "/pam/policy/v2",
      "/pam/policy/v2/createPolicy",

      // Radius
      "/pam/radius",
      "/pam/radius/servers",
      "/pam/radius/onboard",
      "/pam/radius/onboard/microsoftNPS",
      "/pam/radius/logs",
      "/pam/apps",
      "/pam/apps/add",
      "/pam/applications",
      "/pam/applications/new",
      "/pam/applications/signInSource",
      "/pam/settings",
      "/pam/settings/users",
      "/pam/settings/tenantConfig",
      "/pam/settings/logsConfig",
      "/pam/settings/logsConfig/output",

      "/pam/users",
      "/pam/entraUsers",
      "/pam/groups",
      "/pam/directory",
      "/pam/directory/addDirectory/step",
      "/pam/directory/addDirectory",
      "/pam/ai/logs",
      "/pam/ai/troubleshoot",
    ],
  },

  ENDUSER: {
    canAccess: [
      "/endUser/endpoints",
      "/endUser/connections",
      "/endUser/assignedVcs",
      "/endUser/request",
      "/endUser/policies",
    ],
  },
  SUPERADMIN: {
    canAccess: [
      "/org/dashboard",
      "/org/dashboard/details",
      "/setting",
      "/setting/okta",
      "/tenant",
      "/tenant/add",
      "/onboard/module",
      "/onboard",
      "/onboard/config",
      "/onboard/setup/azureAdUser",
      "/onboard/setup/mfa",
      "/onboard/setup/localAccount",
    ],
  },
};

export const authorize = (role, page, id) => {
  if (id) {
    const access = userRoles[role].canAccess.map((path) => {
      path.replace("dynamicId", id);
    });
    if (access.includes(page)) {
      return true;
    }
    return false;
  } else {
    if (userRoles[role].canAccess.includes(page)) {
      return true;
    } else {
      return false;
    }
  }
};
